<template>
  <div class="align_center">
    <el-avatar class="HeadPortrait" :src="newlogo"></el-avatar>
    <el-upload class :before-upload="getDialog" action="" accept="image/jpeg,image/png" :limit="picListLimit" :show-file-list="false">
      <span class="text_blue">{{$t('base.edit')}}</span>
    </el-upload>
    <upload-dialog @uploadImg="uploadImg" :dialogClass="dialogBox" @DialogColse="DialogColse" :domVisible='dislogType.upload' :imgbase="imgbase" v-if='dislogType.upload' />
  </div>
</template>
<script>
import { setInfo } from "@/api/public";
import qs from 'qs';
import UploadDialog from "@/components/dialog/uploaddialog";
import VueCookie from 'vue-cookie'
import Guid from 'guid';
import COS from 'cos-js-sdk-v5'
//var COS = require('cos-js-sdk-v5');
let cos = "";
let cosData = "";

export default {
  name: 'UploadImages',
  components: { UploadDialog },
  data() {
    return {
      newlogo: '',
      FormData: {}, //表单提交值
      //uploadUrl: process.env.VUE_APP_WORLDURL + '/NewCommodity/UploadImage',//&token=+this.$store.state.ChToken
      picListLimit: 1,
      imgbase: '',
      cosConfig: this.$enumInfo.cosConfig,
      dislogType: this.$enumInfo.uoloadType,
      dialogBox: 'dialogBox',
    }
  },
  props: {
    userInfo: Object,
  },
  created() {
    let that = this
    that.NowCos()
    let cook = JSON.parse(VueCookie.get('cardUser'));
    this.newlogo = cook.HeadPortrait
  },
  methods: {
    NowCos() {
      let that = this
      cos = new COS({
        getAuthorization: function(options, callback) {
          if (that.$cookie.get("cosData")) {
            cosData = JSON.parse(that.$cookie.get("cosData"));
            //console.log("$cookie.get.costoken", cosData);
            var credentials = cosData.Credentials;
            var cb = {
              TmpSecretId: credentials.TmpSecretId,
              TmpSecretKey: credentials.TmpSecretKey,
              SecurityToken: credentials.Token,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
              ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
            }
            //console.log("callback",cb);
            callback(cb);
          } else {
            that.$get(that.$interface.costoken, '').then(res => {
              console.log("costoken", res);
              try {
                cosData = res;
                that.$cookie.set("cosData", JSON.stringify(res), { expires: new Date(new Date().getTime() + 1.5 * 60 * 60 * 1000) });
                //console.log("getAuthorization2 - data", cosData);
                var credentials = cosData.Credentials;
              } catch (e) {}
              if (!cosData || !credentials) {
                return console.error('credentials invalid:\n' + cosData)
              };
              var cb = {
                TmpSecretId: credentials.TmpSecretId,
                TmpSecretKey: credentials.TmpSecretKey,
                SecurityToken: credentials.Token,
                // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
                ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
              }
              //console.log("callback",cb);
              callback(cb);
            })
          }
        }
      })
      console.log('COS:', cos)
    },
    //开启/关闭弹框
    DialogColse(val, res) {
      let that = this;
      that.dislogType[val] = res;
    },
    //上传图片之前的方法，判断图片的格式
    getDialog(file) {
      let that = this
      const isJPG = (file.type === 'image/jpeg'||file.type === 'image/png');
      if (!isJPG) {
        this.$message.error(that.$enumInfo.error['NOimg']);
      } else {
        let fileUrl;
        let f = new FileReader()
        //读取es6格式的图片
        f.readAsDataURL(file)
        //文件读取成功之后把图片赋值给imgbase
        f.onload = function(e) {
          fileUrl = this.result
          that.imgbase = fileUrl
          //开启修改弹框
          that.dislogType['upload'] = true;
        }
      }
      return false
    },
    //上传图片
    uploadImg(param) {
      var that = this;
      var uploadType = process.env.NODE_ENV == "development" ? "api" : "cos"; //cos api
      if (uploadType == "cos") {
        var myGuid = Guid.raw();
        var fileType = param.type == 'image/png' ? ".png" : '.jpg';
        var imgKey = that.cosConfig.Prefix + myGuid.replace(/-/g, "") + fileType;
        console.log('file', cosData)
        //上传接口
        cos.putObject({
            Bucket: that.cosConfig.Bucket,
            /* 必须 */
            Region: that.cosConfig.Region,
            /* 存储桶所在地域，必须字段 */
            Key: imgKey,
            /* 必须 */
            Prefix: that.cosConfig.Prefix,
            StorageClass: 'STANDARD',
            Body: param, // 上传文件对象
            Headers: {
              'x-cos-request-id': cosData.RequestId
            },
            onProgress: function(progressData) {
              console.log("onProgress:", JSON.stringify(progressData));
            },
          },
          function(err, data) {
            console.log("err", err);
            console.log("data", data);
            if (err) {
              that.$message.error(this.$t('alert.phoneUrlFail'));
            } else {
              let ImagesUrl = that.cosConfig.ImagesUrl + imgKey
              console.log('ImagesUrl', that.cosConfig.ImagesUrl);
              console.log('imgKey', imgKey);
              that.ChangeHead(ImagesUrl);
            }

          })
      } else if (uploadType == "api") {
        var fd = new FormData();
        //添加并给 file 赋值file文件
        fd.append('file', param);
        this.$post(this.$interface.UploadImage, fd).then(res => {
          if (res.result) {
            //图片上传成功之后的方法
            //console.log("UploadImage", fd, res)
            this.ChangeHead(res.data);
          } else {
            this.$message.error(this.$t('alert.gatImgFail'));
          }
        })
      }
    },
    //更换头像
    ChangeHead(file) {
      let that = this
      console.log("headPortrait", file)
      let data = { "id": this.userInfo.Id, "headPortrait": file }
      this.$post(this.$interface.ChangeHeadPortrait, data).then(res => { //更换头像
        if (res.Result != 0) {
          this.uploadImgSuccess(data.headPortrait)
        } else {
          this.$message({
            message: this.$t('alert.changeHeadImgFail'),
            duration: 1000,
            type: 'error'
          });
          that.dislogType['upload'] = false
        }
      }).catch({})
    },
    //拿到接口返回的图片地址，更新用户信息
    uploadImgSuccess(file) {
      var that = this;
      this.userInfo.HeadPortrait = file
      setInfo('HeadPortrait', file)
      // let domain = process.env.NODE_DOMAIN
      // let time = new Date(new Date().getTime() + 96 * 60 * 60 * 1000)
      // VueCookie.set('cardUser', JSON.stringify(this.userInfo), { domain: domain, expires: time });//创建cookie
      this.newlogo = file;
      location.reload() //刷新
      //关闭修改弹框
      that.dislogType['upload'] = false;
    },

  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.HeadPortrait {
  width: 32px;
  height: 32px;
}.text_blue:hover {
    text-decoration: underline;
}


</style>



// WEBPACK FOOTER //
// src/components/upload-himages.vue